<template>
  <hm-content title="">
    <div class="table-panel flex flex-end">
      <el-date-picker
        class="mr10"
        v-model="searchCondition.applyDate"
        type="datetimerange"
        value-format="yyyy-MM-dd HH:mm:ss"
        start-placeholder="开始日期"
        end-placeholder="结束日期"
        :default-time="['00:00:00', '23:59:59']"
        size="small"
      ></el-date-picker>
      <!-- <el-input
        clearable
        style="width: 250px"
        v-model.trim="searchCondition.textCode"
        placeholder="请输入编码"
        size="small"
        class="ipt mr10"
      ></el-input> -->
      <el-button type="primary" size="small" @click="search">查询</el-button>
    </div>
    <div class="table">
      <el-table
        stripe
        border
        ref="table"
        :data="list"
        style="width: 100%"
        id="table"
        size="small"
      >
        <el-table-column
          type="index"
          label="序号"
          :index="index => index + (currentPage - 1) * pageSize + 1"
        ></el-table-column>

        <el-table-column
          header-align="center"
          align="center"
          prop="createTime"
          label="时间"
        >
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="exceptionClass"
          label="异常类"
          width="300"
          :show-overflow-tooltip="true"
        >
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="exceptionIp"
          label="异常ip"
        >
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="exceptionUrl"
          label="异常请求链接"
        >
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="exceptionStackTrace"
          label="异常堆栈"
          width="300"
          :show-overflow-tooltip="true"
        >
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="exceptionParam"
          label="异常参数"
          :show-overflow-tooltip="true"
        >
        </el-table-column>
        <el-table-column
          label="操作"
          header-align="center"
          align="center"
          width="200px"
        >
          <template slot-scope="scope">
            <el-button size="small" type="text" @click="del(scope.row)"
              >删除</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <div class="hm-pagination">
        <el-pagination
          background
          :total="total"
          @current-change="paging"
          @size-change="handleSizeChange"
          layout="total, sizes, prev, pager, next, jumper"
          :current-page="currentPage"
        ></el-pagination>
      </div>
    </div>
  </hm-content>
</template>

<script>
export default {
  components: {},
  data() {
    return {
      total: 0,
      currentPage: 1,
      pageSize: 10,
      list: [],
      searchCondition: {}
    };
  },
  computed: {},
  watch: {},
  created() {},
  mounted() {
    this.queryList();
  },
  methods: {
    search() {
      this.currentPage = 1;
      this.queryList();
    },
    del(row) {},
    isArray(arr) {
      return Object.prototype.toString.call(arr) === "[object Array]";
    },
    async queryList() {
      const params = {
        pageSize: this.pageSize,
        pageNo: this.currentPage
      };
      const searchCondition = JSON.parse(JSON.stringify(this.searchCondition));
      searchCondition.queryStartTime = this.isArray(searchCondition.applyDate)
        ? searchCondition.applyDate[0]
        : "";
      searchCondition.queryEndTime = this.isArray(searchCondition.applyDate)
        ? searchCondition.applyDate[1]
        : "";

      Object.assign(params, searchCondition);
      const { result } = await this.$store.dispatch(
        "sysExceptionLogList",
        params
      );
      const { records, total } = result;
      this.list = records;
      this.total = total;
    },
    handleSizeChange(size) {
      this.currentPage = 1;
      this.pageSize = size;
      this.queryList();
    },
    paging(page) {
      this.currentPage = page;
      this.queryList();
    }
  }
};
</script>
<style lang="scss" scoped></style>
